/**
 * IE 11
 */
if(window.document.documentMode)
{
    let $html = document.getElementsByTagName("html")[0];
    let $body = document.getElementsByTagName("body")[0];
    let $top = document.getElementById('top');
    $body.classList.remove('min-h-screen');
    $html.classList.remove('min-h-screen');
    $top.classList.remove('flex-1');
    if($body.offsetHeight<window.innerHeight)
    {
        $top.setAttribute("Style", "padding-bottom: " + (window.innerHeight - $body.offsetHeight).toString() + "px");
    }
}

/**
 * Tipsy
 */
import tippy from 'tippy.js';
/**
 * VIMEO
 */
import Player from '@vimeo/player';
/**
 * Datepickers
 */
import {Datepicker} from 'vanillajs-datepicker';

tippy('[data-tippy-content]', {
    allowHTML: true,
    theme: 'light',
});

/**
 * HOWLER
 */
const {Howl, Howler} = require('howler');

window.Player = Player;

/**
 * Livewire Events
 */
document.addEventListener('livewire:init', () => {
    Livewire.on('userLayoutPrefUpdated', layout => {
        for (var $resource of document.querySelectorAll('.resources')) {
            $resource.classList.remove('resources--grid')
            $resource.classList.remove('resources--list');
            $resource.classList.add('resources--' + layout);
        }
    });
});

let $datePickers = document.querySelectorAll(".js--datepicker");
$datePickers.forEach($datePicker => {
    new Datepicker($datePicker, {
        autohide: true,
        disableTouchKeyboard: true,
        format: 'dd-mm-yyyy',
        weekStart: 1,
    });
});
